import React, { Component } from 'react'
import { sha256 } from 'js-sha256'
import { PASSWORD_HASH } from '../../constants'
import { withRouter } from 'react-router'
import { isLoggedIn } from './App'

class PasswordControl extends Component {
  constructor (props) {
    super(props)
    this.checkPassword = this.checkPassword.bind(this)
  }

  goToHome () {
    this.props.history.push('/home')
  }

  checkPassword (event) {
    const text = this.input.value
    const hashedText = sha256(text).toUpperCase()
    console.log('hashedText', hashedText)
    if (hashedText === PASSWORD_HASH) {
      window.localStorage.setItem('password_hash', hashedText)
      this.goToHome()
    } else {
      this.errorText.style = 'opacity: 1'
      setTimeout(() => {
        this.errorText.style = 'opacity: 0'
      }, 5000)
    }
    event.preventDefault()
    event.stopPropagation()
  }

  render () {
    if (isLoggedIn()) {
      this.goToHome()
    }

    return (
      <div>
        <div className='row'>
          <div className='col-6'>
            <h1>CEC Data Repository</h1>
            <p className='lead'>Please enter the password to access this site.</p>
            <form onSubmit={e => this.checkPassword(e)}>
              <div className='input-group'>
                <input className='form-control' type='password' placeholder='Password' ref={input => { this.input = input }} />
                <div className='input-group-append'>
                  <button className='btn btn-outline-primary' type='submit'>Submit</button>
                </div>
              </div>
            </form>
            <p style={{ opacity: 0 }} className='error margin-top text-danger' ref={errorText => { this.errorText = errorText }}>That password is incorrect. Please try again.</p>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(PasswordControl)



// WEBPACK FOOTER //
// ./src/components/App/PasswordControl.js